import { defineStore } from "pinia";
import { publicBoaHttp } from "@/boa-api-client";
import { HTTPError } from "ky";

type State = any;

export default defineStore("twilio", {
  state: (): State => ({}),
  getters: {},
  actions: {
    async startVerify({
      to,
      channel,
      entityKey,
    }: {
      to: string;
      channel: string;
      entityKey: { PK: string; SK: string };
    }): Promise<{ success: boolean; message?: string; status?: number }> {
      try {
        const { success } = (await publicBoaHttp
          .post("start-verify", {
            json: {
              to,
              channel,
              entityKey,
            },
          })
          .json()) as any;
        return { success };
      } catch (error: unknown) {
        if (error instanceof HTTPError) {
          const { message } = await error.response.json();
          return { success: false, status: error.response.status, message };
        }
        return { success: false, message: "Unknown error" };
      }
    },
    async checkVerify({
      to,
      channel,
      code,
      candidateId,
      entityKey,
    }: {
      to: string;
      channel: string;
      code: string;
      candidateId: string;
      entityKey: { PK: string; SK: string };
    }) {
      try {
        const { verified } = (await publicBoaHttp
          .post("check-verify", {
            json: {
              to,
              channel,
              code,
              candidateId,
              entityKey,
            },
          })
          .json()) as any;
        return { verified };
      } catch (error) {
        const { message } = await (error as any).response.json();
        return { success: false, message };
      }
    },
    async verifyInboundCall({
      phones,
      candidateId,
    }: {
      phones: string[];
      candidateId: string;
    }) {
      try {
        const { phones: verifiedPhones = [] } = (await publicBoaHttp
          .post("verify-inbound-call", {
            json: {
              phones,
              candidateId,
            },
          })
          .json()) as any;
        return { verifiedPhones };
      } catch (error) {
        const { message } = await (error as any).response.json();
        return { success: false, message };
      }
    },
    clear() {
      this.$reset();
    },
  },
});
